import { moment } from "./moment";

/**
 * This function calculates the difference in minutes between two date strings.
 * It uses the moment library to parse the date strings and calculate the difference.
 * @param param0
 * @returns
 */
export function getDifferenceInMinutes([start, end]: [string, string]) {
	if (start.startsWith("invalid-")) return 0;
	if (end.startsWith("invalid-")) return 0;
	const startDate = moment(start);
	const endDate = moment(end);
	if (!startDate.isValid() || !endDate.isValid()) return 0;
	const diffInMs = endDate.diff(startDate, "minutes");
	return diffInMs;
}
